module.exports = __webpack_public_path__ + "img/GIF prueba.05948bde.png";